import type { IssueId } from '@atlassian/jira-software-board-common/src/index.tsx';
import { issueChildrenInFinalColumnRest } from '../../rest/issue/issue-children-in-final-column-rest.tsx';
import type { ServiceContext } from '../service-context.tsx';

export const issueChildrenInFinalColumnService = (ctx: ServiceContext, parentId: IssueId) =>
	issueChildrenInFinalColumnRest(parentId, ctx.boardId);
